import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { loadingscreen } from "../../Store";
import PageClosed from "../../Components/PageClosed";
import InformationList from "./InformationList";
import HomeNavbar from "../Homes/Components/HomeNavbar";
import HomeFooter from "../Homes/Components/HomeFooter";

const InformationContainer = () => {
  const setLoading = useSetRecoilState(loadingscreen);
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState({ status: true });
  const { unit } = useParams();
  const getList = () => {
    setLoading(true);
    axios
      .get(`/articles/informasi`)
      .then(function (response) {
        // handle success
        setItems(response.data);
        setLoading(false);
        // console.log(response.data);
      })
      .catch(function (error) {
        // handle error
        setLoading(false);
        // console.log(error.message);
      });
  };
  const getStatus = () => {
    setLoading(true);
    axios
      .get(`/registrations/status`)
      .then(function (response) {
        // handle success
        if (response.status === 200) {
          if (response.data.status) {
            getList();
          } else {
            setOpen(response.data);
          }
        }
        setLoading(false);
        // console.log(response.data);
      })
      .catch(function (error) {
        // handle error
        setLoading(false);
        // console.log(error.message);
      });
  };
  useEffect(() => {
    getStatus();
    return () => {};
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col justify-between bg-white">
      <HomeNavbar />
      {open.status ? (
        <InformationList items={items} unit={unit} />
      ) : (
        <PageClosed content={open.content} />
      )}
      <HomeFooter />
    </div>
  );
};

export default InformationContainer;
